<template>
  <div class="order-delivery">
    <loading v-if="loading"></loading>
    <Head>
      <template #header-left>
        <BaseButton 
          variant="secondary" 
          @click="$router.push(`/orders-delivery`)"
        >
          Quay lại 
        </BaseButton>
      </template>

      <template #title>
        <p>Chi tiết đơn giao hàng</p>
      </template>
      <template #header-right>
        <div v-if="!isSODraft">
          <el-dropdown v-if="checkStatusProcessing && statusActive == 2 && !checkStatusCancel">
            <el-button plain><i class="el-icon-arrow-down el-icon--left"></i>Hủy giao hàng</el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="checkOderFromPartner('popupCancelAndRenew')">Huỷ giao & tạo đơn giao hàng mới</el-dropdown-item>
              <el-dropdown-item class="text-danger" @click.native="checkOderFromPartner('popupCancelAll')">Huỷ giao & huỷ đơn hàng</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- GH chưa đẩy qua hãng -->
          <template v-if="!isPushedToPartner">
            <DiliveryPos
              disabledFeeShip
              @new-dlo-info="changeDLOinfoDone"
              v-if="showDeliveryModal"
              :modalDilivery="showDeliveryModal"
              @clickModalDiliveryHide="showDeliveryModal = false"
              :dloData="dloInfoTmp"
            />
            <el-button type="danger" plain
              @click="showOrderDLOCancel = true"
              v-if="checkStatusDraft && !checkStatusProcessing && !checkStatusCancel"
            >Bỏ giao hàng
            </el-button>

            <el-button 
              type="primary"
              plain
              @click="changeDLOinfo"
              v-if="checkStatusDraft && !checkStatusProcessing && !checkStatusCancel && statusActive == 1"
            >
              Sửa thông tin
            </el-button>
            <el-button 
              type="primary"
              @click="btnConfirmShipperRecieved"
              v-if="checkStatusDraft && !checkStatusProcessing && !checkStatusCancel && statusActive == 1 && !isDELIVERY_PARTNER"
            >
              Giao hàng cho shipper
            </el-button>
            <el-button 
              type="primary"
              @click="btnConfirmShipperRecievedPartner"
              v-if="checkStatusDraft && !checkStatusProcessing && !checkStatusCancel && statusActive == 1 && isDELIVERY_PARTNER"
            >
              Đẩy hàng qua hãng
            </el-button>
          </template>

          <!-- GH đã đẩy qua hãng -->
          <template v-else>
            <el-dropdown class="mr-2" v-if="statusActive == 1 && !checkStatusCancel">
              <el-button plain><i class="el-icon-arrow-down el-icon--left"></i>Hủy giao hàng</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="showPopupCancelAndRenewPartner = true">Huỷ giao & tạo đơn giao hàng mới</el-dropdown-item>
                <el-dropdown-item class="text-danger" @click.native="showPopupCancelAllPartner = true">Huỷ giao & huỷ đơn hàng</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-button 
              type="primary"
              @click="btnConfirmShipperRecieved"
              v-if="checkStatusDraft && !checkStatusProcessing && !checkStatusCancel && statusActive == 1"
            >
              Giao hàng cho shipper
            </el-button>
          </template>

          <el-button 
            type="primary"
            style="margin-left: 10px"
            @click="popupConfirmItemsDelivered = true"
            v-if="checkStatusProcessing && statusActive == 2 && !checkStatusFail"
          >
            Giao hàng thành công
          </el-button>
        </div>
      </template>
    </Head>

    <div class="boxContent boxContentExt" style="margin-top: 110px;">
      <div class="boxProgress">
        <el-steps :active="statusActive" align-center>
          <el-step 
            v-for="(status, index) in statusOrder" 
            :key="index"
            :description="status.description"
            :title="status.statusTitle"
            :icon="status.processorStatus == 'CANCEL' || status.processorStatus == 'FAILED' ? 'el-icon-circle-close' : ''"
            >
          </el-step>
        </el-steps>
      </div>
    </div>

    <div class="boxContent boxContentExt">
      <div class="__card">
        <h1 class="__card_title">Thông tin đơn vận:</h1>
        <el-form label-width="140px" style="width: 100%;" :inline="true">
          <el-row>
            <el-col :span="12">
              <el-form-item label="Mã đơn giao:" class="m-0">
                <strong class="mr-3"> {{checkEmpty(dataItem.orderNo)}}</strong>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="TG xuất kho:" class="m-0">
                <strong class="mr-3"> {{checkoutAt}}</strong>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="Mã đơn hàng:" class="mb-0">
                <strong> {{ checkEmpty(dataItem.furtherInstructions[0].params.soOrderNo) }}</strong>
                <a class="text-primary cursor" @click="linkTo()" style="padding-left: 8px;">
                  <i class="fa-solid fa-up-right-from-square mr-1"></i> Chi tiết đơn hàng
                </a>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Ngày mua:" label-width="140px" class="mb-0">
                <span>{{ checkEmpty(this.timeFormatStatus(dataItem.createdAt)) }}</span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="Người tạo:" class="mb-0">
                <span>{{ checkEmpty(dataItem.partyA.displayName) }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="Địa chỉ lấy hàng:" class="mb-0">
                <span>{{checkEmpty(dataItem.furtherInstructions[0].params.pickUpAddress)}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="Ghi chú:" class="mb-0">
                <span>{{checkEmpty(dataItem.note)}}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <div class="boxContent boxContentExt">
      <div class="__card">
        <h1 class="__card_title">Người nhận</h1>
        <el-form label-width="140px" style="width: 100%;" :inline="true">
          <el-row>
            <el-col :span="24">
              <el-form-item label="Họ và tên:" class="mb-0">
                <span>{{ checkEmpty(dataItem.partyB.displayName) }}</span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="Điện thoại:" class="mb-0">
                <span>{{ checkEmpty(dataItem.partyB.phoneNo) }}</span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="Tỉnh/Thành phố:" class="mb-0">
                <span>{{ checkEmpty(shippingCity) }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Quận/Huyện:" label-width="140px" class="mb-0">
                <span>{{ checkEmpty(shippingDistrict) }}</span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="Phường/Xã:" class="mb-0">
                <span>{{ checkEmpty(shippingVillage) }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Địa chỉ cụ thể:" class="mb-0">
                <span style="word-break: break-all">{{ checkEmpty(dataItem.furtherInstructions[0].params.shippingAddress)}}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <div class="boxContent boxContentExt">
      <div class="__card">
        <h1 class="__card_title">Hình thức giao hàng</h1>
        <el-form label-width="140px" style="width: 100%;" :inline="true">
            <el-row>
                <el-col :span="12">
                  <el-form-item v-if="isDELIVERY_PARTNER" label="Đối tác:" class="mb-0">
                    <span>{{checkEmpty(DELIVERY_INFO_DATA && DELIVERY_INFO_DATA.partnerCode)}}</span>
                  </el-form-item>
                  <el-form-item v-else label="Đối tác:" class="mb-0">
                    <span>{{checkEmpty(getTargetService)}}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Tiền thu hộ COD:" label-width="140px" class="mb-0">
                    <span>{{formatMoneyNotUnit(CODfee) || 0}}</span>
                  </el-form-item>
                </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item v-if="isDELIVERY_PARTNER" label="Gói vận chuyển:" class="mb-0">
                  <span>{{checkEmpty(DELIVERY_INFO_DATA && DELIVERY_INFO_DATA.partnerPackageName)}}</span>
                </el-form-item>
                <el-form-item v-else label="Họ và tên:" class="mb-0">
                  <span>{{checkEmpty(dataItem.partyOther.displayName)}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item v-if="!isDELIVERY_PARTNER" label="Số điện thoại:" label-width="140px" class="mb-0">
                  <span>{{checkEmpty(dataItem.partyOther.phoneNo)}}</span>
                </el-form-item>
              </el-col>
            </el-row>
            
            <el-row>
              <el-col :span="12">
                <el-form-item label="Phí trả ĐTGH:" class="mb-0">
                  <span>{{formatMoneyNotUnit(dataItem.lineItemFinalizing.finalAmount / 1000)}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Phí báo khách:" label-width="140px" class="mb-0">
                  <span>{{formatMoneyNotUnit(shippingFee)}}</span>
                </el-form-item>
              </el-col>
            </el-row>
        </el-form>
      </div>
    </div>

    <div class="boxContent boxContentExt">
      <div class="__card">
        <h1 class="__card_title">Lịch sử thao tác</h1>
        <el-row style="width: 100%">
          <b-table
            :items="dataHistory"
            :fields="fields"
            emptyText="Đơn chưa có thanh toán nào"
            show-empty
          >
          </b-table>
          <!-- <el-table :data="dataHistory" style="width: 100%">
            <el-table-column label="" width="50" type="index" align="center"></el-table-column>
            <el-table-column
               label="Thời gian"
               width="300"
            >
              <template slot-scope="scope">
                {{ checkEmpty(scope.row.modifiedAt) }}
              </template>
            </el-table-column>
            <el-table-column
               label="Thao tác"
               width="300"
               prop="action"
            >
            </el-table-column>
            <el-table-column
               label="Người thực hiện"
               width="250"
               prop="modifiedByName"
            >
            </el-table-column>
          </el-table> -->
        </el-row>
      </div>
    </div>

    <el-dialog title="Xác nhận huỷ giao & huỷ đơn hàng" :visible.sync="popupCancelAll" width="600px">
      <deliveryCancelPopUp :isCustomerPaid="isCustomerPaid" :dataItem="dataItem" :isCancelAll="true" @updateStatus="fetchData" @closeModal="popupCancelAll = false"/>
    </el-dialog>

    <el-dialog title="Xác nhận huỷ giao & tạo đơn giao hàng mới" :visible.sync="popupCancelAndRenew" width="600px">
      <deliveryCancelPopUp :dataItem="dataItem" :isCancelAndReNew="true" @updateStatus="fetchData" @closeModal="popupCancelAndRenew = false"/>
    </el-dialog>

    <CancelAndCloneOrder :isCustomerPaid="isCustomerPaid" :datas="datas" :show="showOrderDLOCancel" :DLOid="DLOid" @close="showOrderDLOCancel = false"></CancelAndCloneOrder>

    <el-dialog
      title="Xác nhận giao hàng thành công"
      :visible.sync="popupConfirmItemsDelivered"
      width="600px"
    >
      <div class="text-center">
        <img src="@/assets/images/delivery-img/Delivery-done.png" alt="icon">
        <p class="mb-0">Xác nhận đã giao hàng cho khách.</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <b-overlay
          :show="busy"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block loading-btn"
        >
          <el-button type='primary' :disabled="busy" @click="btnConfirmDeliveredItems">
            Xác nhận
          </el-button>
        </b-overlay>
      </span>
    </el-dialog>

    <!-- modal -->
    <el-dialog custom-class="popup-pos-detail" width="600px" title="Xác nhận huỷ giao & tạo đơn giao hàng mới" :visible.sync="showPopupCancelAndRenewPartner">
      <div class="text-center" style="display: flex;flex-direction: column;align-items: center;">
        <img src="@/assets/images/icon-discard-file.svg" alt="icon" />
        <p class="mb-3" style="width:70%">
          Đơn giao hàng hiện tại sẽ <b>bị huỷ</b>, vui lòng
          <b
            >tạo 1 đơn <br />
            giao hàng mới</b
          >
          để tiếp tục bán.
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="confirmCancelAndRenewPartner" type="primary">Xác nhận</el-button>
      </span>
    </el-dialog>

    <el-dialog custom-class="popup-pos-detail" width="600px" title="Xác nhận huỷ giao & huỷ đơn hàng" :visible.sync="showPopupCancelAllPartner">
      <div class="text-center">
        <img src="@/assets/images/icon-discard-file.svg" alt="icon" />
        <p class="mb-3">Đơn giao và đơn hàng sẽ <b>bị huỷ</b></p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="confirmCancelAllPartner" type="primary">Xác nhận hủy</el-button>
      </span>
    </el-dialog>

    <el-dialog custom-class="popup-pos-detail" width="600px" title="Liên hệ để hủy đơn" :visible.sync="showIsNotCancel">
      <div class="text-center" style="display: flex;flex-direction: column;align-items: center;">
        <img src="@/assets/order-icon/Delivery_hand_nope.png" alt="icon" />
        <div>Hàng đã được giao cho đối tác vận chuyển, vui lòng liên hệ<br>tổng đài Hey U <a  href="tel:+841900633689" class="text-primary">1900633689</a> để được hỗ trợ. </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showIsNotCancel = false" type="primary">Đóng</el-button>
      </span>
    </el-dialog>

    <el-dialog custom-class="popup-pos-detail" title="Giao hàng không thành công" width="600px" :visible.sync="showExport" :show-close="false">
      <div class="body">
        <div class="image" style="height: 120px">
          <img src="@assets/order-icon/Box-decline.png" />
        </div>
        <div class="mt-3 text-center text-break">
          Chưa thể giao hàng do <b>thiếu thông tin sản phẩm</b> cho đơn<br>
          từ Gian hàng trực tuyến. Vui lòng đi tới đơn hàng để thêm<br>
          chi tiết sản phẩm
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="linkTo" plain type="primary">Đến chi tiết đơn hàng</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import Head from "./components/head.vue"
import deliveryCancelPopUp from "@/components/delivery-cancel-popup.vue"
import CancelAndCloneOrder from "@/pages/pos/components/CancelAndCloneOrder.vue"
import { OrdersService } from "@/services/nextshop/orders.service"
import { OtherService } from "@/services/other.service";
import { LocationService } from "@/services/nextshop/location.service"
import { formatHHmmDDMMYYYY } from "../../utils/format";
import _ from "lodash"
import { setStorageItem } from "@/utils/auth";
import getPosDloInfo from "@/utils/delivery";
import convertDataFromDLOform from "@/utils/delivery";
import DiliveryPos from "../V2/pos/components/dilivery.vue";
import deliveryMixin from "../pos/deliveryMixin.js"



// import Swal from "sweetalert2"

export default {
  name: "orders-delivery-detail",
  mixins: [getPosDloInfo, convertDataFromDLOform, deliveryMixin],
  components: {
    Head,
    deliveryCancelPopUp,
    CancelAndCloneOrder,
    DiliveryPos
  },
  data() {
    return {
      loading: false,
      id: this.$route.params.id,
      dataItem: {},
      dataLocation: {},
      dataHistory: [],
      statusOrder: [],
      statusActive: 1,
      popupConfirmItemsDelivered: false,
      popupCancelAndRenew: false,
      popupCancelAll: false,
      showOrderDLOCancel: false,
      showIsNotCancel: false,
      showExport: false,
      DLOid: '',
      datas: {},
      fields: [
        {
          key: "modifiedAt",
          label: "Thời gian",
        },
        {
          key: "action",
          label: "Thao tác",
        },
        {
          key: "modifiedByName",
          label: "Người thức hiện",
        },
      ],
      busy: false,
      CODfee: '',
      shippingFee: 0,
      shippingCity: "",
      shippingDistrict: "",
      shippingVillage: "",
      checkStatusDraft: false,
      checkStatusProcessing: false,
      checkStatusComplete: false,
      checkStatusCancel: false,
      checkStatusFail: false,
      isCustomerPaid: false,
      isSODraft: false,
      showPopupCancelAndRenewPartner: false,
      showPopupCancelAllPartner: false,
      showDeliveryModal: false,
      dloInfoTmp: null
    }
  },

  async created() {
    this.loading = true
    await this.fetchData()
    await this.getDataLocation()
    this.loading = false
  },

  filters: {
    formatPercent(value) {
      return Math.floor(value * 100);
    },
  },


  methods: {
    async fetchData() {
      this.statusOrder = []
      this.loading = true

      try {
        const response = await OrdersService.getDetailOrderDelivery(this.id)
        if (response.success) {
          this.loading = false
          this.dataItem = response.data.data;
          await this.getDetailSO(this.dataItem.furtherInstructions[0].params.soOrderId);
          this.checkPayment();
          
          const checkStatusDraft = this.dataItem.statusHistory.find(status =>  { return status.processorStatus === 'NEW' || status.processorStatus === 'DRAFT'})
          const checkStatusProcessing = this.dataItem.statusHistory.find(status => status.processorStatus === 'PROCESSING')
          const checkStatusCancel = this.dataItem.statusHistory.find(status => { return status.processorStatus == 'CANCEL' || status.processorStatus == 'FAIL'})
          const checkStatusComplete = this.dataItem.statusHistory.find(status => status.processorStatus == 'COMPLETE')
          const checkStatusFail = this.dataItem.statusHistory.find(status => { return status.processorStatus == 'FAILED' })

          const draft = {
            ...checkStatusDraft,
            statusTitle: "Tạo đơn",
            description: formatHHmmDDMMYYYY(checkStatusDraft.modifiedAt) || ''
          }
          const processing = {
            ...checkStatusProcessing,
            statusTitle: "Đang tiến hành",
            description: checkStatusProcessing ? formatHHmmDDMMYYYY(checkStatusProcessing.modifiedAt) : ''
          }
          const complete = {
            ...checkStatusComplete,
            statusTitle: "Hoàn thành",
            description: checkStatusComplete ? formatHHmmDDMMYYYY(checkStatusComplete.modifiedAt) : ''
          }
          const cancel = {
            ...checkStatusCancel,
            statusTitle: "Hủy",
            description: checkStatusCancel ? formatHHmmDDMMYYYY(checkStatusCancel.modifiedAt) : ''
          }
          const fail = {
            ...checkStatusFail,
            statusTitle: "Hủy",
            description: checkStatusFail ? formatHHmmDDMMYYYY(checkStatusFail.modifiedAt) : ''
          }
          this.statusOrder.push(draft,processing,complete)
          
          if(checkStatusDraft) {
            this.checkStatusDraft = true
            this.statusActive = 1;
          }
          if(checkStatusProcessing) {
            this.statusActive = 2;
            this.checkStatusProcessing = true
          }
          if(checkStatusComplete) {
            this.statusActive = 3;
            this.checkStatusComplete = true
          }
          if(checkStatusCancel) {
            this.statusActive = 2;
            this.checkStatusCancel = true
            this.statusOrder = [draft, cancel]
          }
          if(checkStatusFail) {
            this.statusActive = 3;
            this.checkStatusFail = true
            this.statusOrder = [draft, processing, fail]
          }

          this.getShippingAddress(this.dataItem.furtherInstructions[0].params);
          
          this.dataHistory = JSON.parse(this.dataItem.furtherInstructions[1].params.actionsHistory).map(e => {
            return {
              ...e,
              modifiedAt: formatHHmmDDMMYYYY(e.modifiedAt),
            }
          })

          this.dataHistory.filter((e) => {
            switch(e.action) {
              case "CREATE":
                e.action = "Tạo đơn"
                break
              case "UPDATE_INFO":
                e.action = "Cập nhật thông tin"
                break
              case "CONFIRM":
                e.action = "Giao hàng cho shipper"
                break
              case " UPDATE_STATUS":
                e.action = "Cập nhập trạng thái"
                break
              case "CANCEL":
                e.action = "Hủy giao"
                break
              case "UPDATE_FAILED":
                e.action = "Thất bại"
                break
              case "COMPLETE" :
                e.action = "Giao hàng thành công"
            }
          })
        }
      } catch (error) {
        console.log(error);
      }
        //trạng thái đơn hàng
        this.loading = false;
    },

    async getDetailSO(id) {
      try {
        const response = await OrdersService.getOrderById(id);
        if (response.success) {
          this.datas = response.data;
          if (this.datas.processorStatus == 'NEW') {
            this.isSODraft = true;
          }
          if(this.datas.furtherInstructions) {
            const deliveryData = this.datas.furtherInstructions.find(item => item.key == "SO_ORDER_OPERATION")
            if (deliveryData) {
              if (deliveryData.params && deliveryData.params.deliveryStatus && deliveryData.params.deliveryStatus != null) {
                deliveryData.params.deliveryHistory = JSON.parse(deliveryData.params.deliveryHistory ? deliveryData.params.deliveryHistory : "[]" )
                const deliveryHistoryLast = deliveryData.params.deliveryHistory.at(-1)
                this.DLOid = deliveryHistoryLast.deliveryOrderId
              }
            }
          }
          let checkShippingFee = response.data.lineItemFinalizing.addedFee.find(e => e.key == 'SHIPPING_FEE')
          if(checkShippingFee) {
            this.shippingFee = checkShippingFee.amount / 1000
          } else {
            return '-'
          }

          let checkCOD = response.data.outcomes.find(e => e.key == 'COD_NEXT_SHOP')
          if(checkCOD) {
            this.CODfee = checkCOD.params.amount / 1000
          } else {
            return '-'
          }
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getShippingAddress(params) {
      const cityCode = params.shippingCity;
      const districtCode = params.shippingDistrict;
      const villageCode = params.shippingVillage;
      //get city name
      const cityRes = await OtherService.getlistCity();
      let shippingCity = cityRes.data.find(e => {
        return e.code == cityCode
      })
      this.shippingCity = shippingCity.name

      //get district name
      const districtRes = await OtherService.getlistDistrict({
        cityCode: cityCode,
        countryCode: "vn",
      });
      let shippingDistrict = districtRes.data.find(e => {
        return e.code == districtCode
      })
      this.shippingDistrict = shippingDistrict.name

      //get village name
      const villageRes = await OtherService.getlistWard({
        cityCode: cityCode,
        countryCode: "vn",
        districtCode: districtCode,
      });
      let shippingVillage = villageRes.data.find(e => {
        return e.code == villageCode
      })
      this.shippingVillage = shippingVillage.name
    },


    async getDataLocation(locationId) {
      try {
        const response = await LocationService.getDetailLocation(
          {locationId: locationId}
        )
        if (response.success) {
          this.dataLocation = response.data
        }
      } catch (error) {
        console.log(error)
      }
    },

    async btnConfirmShipperRecieved() {

      if (this.isOrderFormOnlineStore && !this.isExportOrder) {
        this.showExport = true
        return
      }

      this.loading = true;
      this.busy = true;
      try {
        // const response = await OrdersService.changeDloStatusToProcessing(this.id)
        const response = await OrdersService.deliveryToShipperApi({
          "id": this.id
        })
        if (response.success) {
          this.loading = false;
          this.busy = false;
          this.statusOrder = []
          this.statusActive = 1;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
        this.busy = false;
        this.fetchData();
      }
    },

    async btnConfirmShipperRecievedPartner() {
      if (this.isOrderFormOnlineStore && !this.isExportOrder) {
        this.showExport = true
        return
      }
      this.loading = true;
      this.busy = true;
      try {
        // const response = await OrdersService.changeDloStatusToProcessing(this.id)
        const response = await OrdersService.deliveryToPartnerApi({
          "id": this.id
        })
        if (response.success) {
          this.loading = false;
          this.busy = false;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
        this.busy = false;
        this.fetchData();
      }
    },

    async btnConfirmDeliveredItems() {
      this.loading = true;
      this.busy = true;
      try {
        const response = await OrdersService.updateStatusByMerchant(
          {
            orderId: this.id,
            isCancelSO: false,
            newStatus: "COMPLETE",
            returnFee: 0
          }
        )
        if (response.success) {
          this.busy = false
          this.loading = false
          this.popupConfirmItemsDelivered = false
          this.showSwalSuccess("Giao hàng cho khách")
          this.statusOrder = []
          this.statusActive = 1;
        }
      } catch (error) {
        this.showSwalError("Giao hàng cho khách", error);
        console.log(error);
      } finally {
        this.loading = false;
        this.busy = false;
        this.fetchData();
      }
    },

    checkPayment() {
      const outcomes = this.datas.outcomes;
      if (outcomes.length > 0) {
        let payment = (outcomes.filter(e => e.cat == 'NSH_PAYMENT'))
        for (let item of payment) {
          if(item.params && item.params.status == 'SUCCESS') {
            this.isCustomerPaid = true
          }
        }
      }
    },

    checkEmpty(val) {
      if (val == "" || val == null || val == undefined) {
        return " - "
      } else {
        return val
      }
    },

    linkTo() {
      this.$router.push({ path: `/pos/pos-detail/${this.dataItem.furtherInstructions[0].params.soOrderId}`})
    },

    async confirmCancelAndRenewPartner() {
      const params = {
        "keepSO": true,
        orderId: this.id,
        reason: "",
      }
      // console.log(params)
      // return
      try {
        this.loading = true;
        const res = await OrdersService.cancelBeforeConfirm(params); // check lai
        if (res.success) {
          this.showPopupCancelAndRenewPartner = false;
          this.showSwalSuccess("Hủy đơn hàng");
          this.$router.push({path: `/pos/pos-detail/${this.dataItem.furtherInstructions[0].params.soOrderId}`,query: {isReNew: true}})
        } else {
          this.showSwalError("Hủy đơn hàng", res.message);
        }
      } catch (error) {
        console.log(error);
        this.showSwalError("Hủy đơn hàng");
      } finally {
        this.loading = false;
      }
    },
    async confirmCancelAllPartner() {
      const params = {
        "keepSO": false,
        orderId: this.id,
        reason: "",
      }
      // console.log(params);
      // return
      try {
        this.loading = true;
        const res = await OrdersService.cancelBeforeConfirm(params);
        if (res.success) {
          await this.fetchData();
          this.showSwalSuccess("Hủy đơn hàng");
          this.showPopupCancelAllPartner = false;
        } else {
          this.showSwalError("Hủy đơn hàng", res.message);
        }
      } catch (error) {
        console.log(error);
        this.showSwalError("Hủy đơn hàng");
      } finally {
        this.loading = false;
      }
    },
    async changeDLOinfo() {
      // SỬA THÔNG TIN SỬ DỤNG COMPONENT DELIVERY
      this.loading = true;
      const posDloInfo = await this.getPosDloInfo(this.dataItem, this.shippingFee);
      // console.log(123, posDloInfo)
      // await setStorageItem("posDloInfoDetail", JSON.stringify(posDloInfo));
      this.dloInfoTmp = null
      this.dloInfoTmp = _.cloneDeep(posDloInfo)
      this.showDeliveryModal = true;
      this.loading = false;
    },
    async changeDLOinfoDone(dloInfo) {
      // console.log(111 ,dloInfo)
      const newDloInfoConverted = this.convertDataFromDLOform(dloInfo)
      await this.updateDLO(newDloInfoConverted);
    },
    async updateDLO(posDloInfo) {
      // sua don giao hang hien tai
      this.loading = true;
      try {
        const params = _.cloneDeep(posDloInfo)
        delete params.pickUpAddress
        delete params.addFeesShipping
        params.deliveryServicePack = posDloInfo.deliveryServicePack.packageInfo.id? posDloInfo.deliveryServicePack : null
        params.orderId = this.dataItem.id
        // console.log(123, {posDloInfo, params})
        // return

        const res = await OrdersService.updateInforDLO(params);
        if (res.success) {
          this.showSwalSuccess("Sửa thông tin giao hàng");
          this.showDeliveryModal = false;
          await this.fetchData();
        }
      } catch (error) {
        this.showSwalError("Sửa thông tin giao hàng");
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    checkOderFromPartner(key) {
      if(this.isDELIVERY_PARTNER && this.checkStatusProcessing) {
        this.showIsNotCancel = true
        return
      } else {
        this[key] = true
      }
    },
  },

  computed: {
    getTargetService() {
      if (this.dataItem.targetService == 'DELIVERY_PRIVATE_SHIPPER') {
        return 'Tự gọi shipper'
      } else if (this.dataItem.targetService == 'DELIVERY_PARTNER') {
        return 'Đẩy đơn qua hãng'
      }
      return ''
    },
    
    checkoutAt() {
      return formatHHmmDDMMYYYY(this.dataItem.furtherInstructions[0].params.checkoutAt) || '-'
    },
    isDELIVERY_PARTNER() {
      return this.dataItem.targetService == "DELIVERY_PARTNER"
    },
    DELIVERY_INFO_DATA() {
      const DELIVERY_INFO = this.dataItem.furtherInstructions && this.dataItem.furtherInstructions.find((e) => e.key == "DELIVERY_INFO");
      return DELIVERY_INFO.params ? DELIVERY_INFO.params : null ;
    },
    isPushedToPartner() {
      return this.DELIVERY_INFO_DATA && this.DELIVERY_INFO_DATA.isPushedToPartner ?  this.DELIVERY_INFO_DATA.isPushedToPartner : false
    },
    isOrderFormOnlineStore() {
      return this.datas.targetMethod === "SALE_ONLINE_STORE" && this.datas.orderStatus == "DRAFT"
    },
    isExportOrder() {
      if (!this.datas || !this.datas.outcomes) return false;
      const exportInfor = this.datas.outcomes.find((e) => e.cat === "NSH_CHECKOUT");
      return exportInfor && exportInfor.params ? true : false;
    },
  },
}

</script>

<style lang="scss" scoped>
* {
    word-break: normal;
}
.boxContent {
  margin: 12px 0;
}
.el-form-item__content {
  width: 60%;
}

.boxContentExt {
  .__card {
    width: 100%;
    max-width: 960px;
    margin: auto;
    max-width: 960px;
    background: #ffffff;
    -webkit-box-shadow: 0px 0px 12px -4px rgba(0, 0, 0, 0.08), 0px 8px 12px -8px rgba(0, 0, 0, 0.16);
    box-shadow: 0px 0px 12px -4px rgba(0, 0, 0, 0.08), 0px 8px 12px -8px rgba(0, 0, 0, 0.16);
    border-radius: 8px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
    padding: 24px;
  }

  .__card_title{
    font-style: normal;
    font-weight: bold!important;
    font-size: 18px;
    line-height: 30px;
    letter-spacing: -0.01em;
    color: #23313e;
  }
}

.loading-btn {
    margin-left: 30px;
}


.boxProgress {
  display: flex;
  justify-content: center;
  // margin: 100px auto 0;
  .el-steps.el-steps--horizontal {
    .el-step.is-horizontal {
      flex-basis: unset;
      margin-right: initial;
      width: 350px;
    }

    .el-step {
      .el-step__description {
        margin: 10px 0;
      }
    }
  }
}

ul {
  padding: 0;
  margin: 0;
}

.cancel-info {
  padding: 10px 16px;
  height: 64px;
  background: #FEF5E1;
  border-radius: 4px;
  margin: 30px 0;
}
</style>

<style lang="scss">
.order-delivery {
  .el-tabs__item {
    font-size: 20px;
    font-weight: 600;
    color: #ddd;
  }
  .el-tabs__item.is-active {
    color: #23313e;
  }

  .el-tabs__header {
    margin: 0 0 24px;
  }
  
  .table td{
    height: 68px;
  }
  .select-item {
    display: inline-block;
    background-color: #F2F3F4;
    padding: 6px;
    margin: 0 10px 10px 10px;
    border-radius: 4px;
  }
  .border-top {
    border-top: 1px solid rgb(242, 243, 244);
  }
}
</style>